import { Input } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Filter from '../../Filter/Filter';
import { FILTER_TYPE } from './constants';

const useSearchOptions = (params, handleOnChangeFilter) => {
  const { t } = useTranslation('Vindoc');

  const InputItem = (params, key, placeholder = t('Keyword')) => {
    return (
      <Input
        size="small"
        className="w-[200px] max-w-full"
        value={params[key]}
        placeholder={placeholder}
        onChange={(event) => handleOnChangeFilter(params, key, event?.target?.value)}
        onPressEnter={(event) => handleOnChangeFilter(params, key, event?.target?.value, true)}
      />
    );
  };

  return useMemo(
    () => [
      {
        text: t('Full Name'),
        key: FILTER_TYPE.FULLNAME,
        component: InputItem(params, FILTER_TYPE.FULLNAME),
      },
      {
        text: t('Username'),
        key: FILTER_TYPE.USERNAME,
        component: InputItem(params, FILTER_TYPE.USERNAME),
      },
      /* {
        text: t('Status'),
        hidden: false,
        key: 'statuses',
        component: (
          <Filter.Status
            value={params.statuses}
            title={false}
            mode="multiple"
            placeholder={t('Select Status')}
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.STATUS, value, true);
            }}
          />
        ),
      }, */
      {
        text: t('Institution'),
        key: FILTER_TYPE.INSTITUTION,
        component: (
          <Filter.Institution
            title={false}
            disabled
            value={params[FILTER_TYPE.INSTITUTION] || []}
            keyValue="code"
            onChange={(value) => {
              handleOnChangeFilter(params, FILTER_TYPE.INSTITUTION, value, true);
            }}
          />
        ),
      },
    ],
    [t, params, handleOnChangeFilter]
  );
};

export default useSearchOptions;
